import AddIcon from "@mui/icons-material/Add";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Grid,
  Pagination,
  TableCell,
  TableFooter,
  TableRow,
  Typography,
} from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import CustomSelect from "../../../../components/Select/Select";
import {
  getAllServiceAppointmentsReportData,
  getServiceAppointmentsReportData,
} from "../../../../redux/reducers/reportSlice";
import { AppColors } from "../../../../util/AppColors";
import { w20h20BlueIcon } from "../../../../util/CommonIconStyle";
import { ServiceTypes } from "../../../../util/dropList";
import ReportTable from "../ReportTable";
import { nameExpan } from "../tableHeaders";

const tableHdrs = [
  "appointmentDateAndTime",
  "vetName",
  "petName",
  "serviceName",
  "revenue",
  "discount",
  "discountCode",
  "timeSpent",
  "type",
  "category",
  "subcategory",
  "sacCode",
  "variantName",
  "variantNumber",
  "sellingPrice",
];
const filterByList = [
  "Appt Date",
  "Revenue",
  "Discount",
  // "Discount Code",
  "Time Spent",
  "Type",
  "Subcategory",
  "SAC Code",
  "Variant Name",
  "Variant ID",
  "Selling Price",
];
const dropFields = ["Type", "Subcategory"];
const splitRows = [
  "Appt Date",
  "Revenue",
  "Discount",
  "Time Spent",
  "Selling Price",
];

const initSearch = {
  vetName: "",
  petName: "",
  serviceName: "",
  category: [],
};
const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};

const ServiceLevel2Report = () => {
  const dispatch = useDispatch();
  const [crntTblHeders, setCrntTblHeders] = useState(tableHdrs?.slice(0, 5));
  const [activeTableHeaders, setActiveTableHeaders] = useState(
    tableHdrs?.slice(0, 5)?.map((pd, i) => ({ name: pd, isSelected: true, i })),
  );
  const [editColModVsble, setEditColModVsble] = useState(false);
  const [page, setPage] = useState(1);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [filterValues, setFilterValues] = useState(initFilter);
  const { serviceAppointments, allServiceAppointments } = useSelector(
    (state) => state?.report,
  );
  const rowsPerPage = 10;

  useEffect(() => {
    dispatch(getAllServiceAppointmentsReportData());
  }, [dispatch]);

  useEffect(() => {
    onApiCall(1);
  }, [
    searchValues?.vetName,
    searchValues?.petName,
    searchValues?.serviceName,
    searchValues?.category,
  ]);

  const getFilterObj = (currentPage = 1, reset = false) => {
    setPage(currentPage);
    const reqObj = { type: "detail", page: currentPage, itemSize: rowsPerPage };
    if (reset) return reqObj;
    if (searchValues?.vetName?.length > 0) {
      reqObj.vetName = [searchValues?.vetName];
    }
    if (searchValues?.petName?.length > 0) {
      reqObj.petName = [searchValues?.petName];
    }
    if (searchValues?.serviceName?.length > 0) {
      reqObj.serviceName = [searchValues?.serviceName];
    }
    if (searchValues?.category?.length > 0) {
      reqObj.category = searchValues?.category?.map((li) => li?.value);
    }

    if (filterValues?.selectedList?.includes("Type")) {
      reqObj.serviceType = filterValues?.values?.["Type"]?.map(
        (li) => li?.value,
      );
    }
    if (filterValues?.selectedList?.includes("Subcategory")) {
      reqObj.subcategory = filterValues?.values?.["Subcategory"]?.map(
        (li) => li?.value,
      );
    }
    if (filterValues?.selectedList?.includes("SAC Code")) {
      reqObj.hsnSacCode = [filterValues?.values?.["SAC Code"] ?? ""];
    }
    if (filterValues?.selectedList?.includes("Variant ID")) {
      reqObj.variantNumber = [filterValues?.values?.["Variant ID"] ?? ""];
    }
    if (filterValues?.selectedList?.includes("Variant Name")) {
      reqObj.variantName = [filterValues?.values?.["Variant Name"] ?? ""];
    }
    if (filterValues?.selectedList?.includes("Appt Date")) {
      reqObj.startDate = moment(
        new Date(filterValues?.values?.["Min Date"] ?? new Date()),
      ).format("YYYY-MM-DD");
      reqObj.endDate = moment(
        new Date(filterValues?.values?.["Max Date"] ?? new Date()),
      ).format("YYYY-MM-DD");
    }
    if (filterValues?.selectedList?.includes("Revenue")) {
      reqObj.minRevenue = Number(filterValues?.values?.["Min Revenue"] ?? 0);
      reqObj.maxRevenue = Number(filterValues?.values?.["Max Revenue"] ?? 0);
    }
    if (filterValues?.selectedList?.includes("Discount")) {
      reqObj.minDiscount = Number(filterValues?.values?.["Min Discount"] ?? 0);
      reqObj.maxDiscount = Number(filterValues?.values?.["Max Discount"] ?? 0);
    }
    if (filterValues?.selectedList?.includes("Time Spent")) {
      reqObj.minTimeSpent = Number(
        filterValues?.values?.["Min Time Spent"] ?? 0,
      );
      reqObj.maxTimeSpent = Number(
        filterValues?.values?.["Max Time Spent"] ?? 0,
      );
    }
    if (filterValues?.selectedList?.includes("Selling Price")) {
      reqObj.minSellingPrice = Number(
        filterValues?.values?.["Min Selling Price"] ?? 0,
      );
      reqObj.maxSellingPrice = Number(
        filterValues?.values?.["Max Selling Price"] ?? 0,
      );
    }
    return reqObj;
  };

  const onApiCall = (pge = 1, reset = false) => {
    dispatch(getServiceAppointmentsReportData(getFilterObj(pge, reset)));
  };

  const handleEditColumn = () => {
    const reqList = tableHdrs?.map((pd, i) => {
      const isObjMat = activeTableHeaders?.find(
        (tblHdr) => tblHdr?.name === pd,
      );
      return { name: pd, isSelected: isObjMat?.isSelected ?? false, i };
    });
    setActiveTableHeaders(reqList);
    setEditColModVsble(true);
  };

  const onEditModClose = () => {
    setEditColModVsble(false);
  };

  const handleSelcetdColumn = (selected, ind) => {
    const reqList = activeTableHeaders?.map((act, i) => {
      if (i === ind) return { ...act, isSelected: selected };
      return act;
    });
    setActiveTableHeaders(reqList);
  };

  const handleSaveTableColumn = () => {
    const reqList = activeTableHeaders
      ?.filter((act) => act?.isSelected)
      ?.map((act) => {
        return act?.name;
      });
    setCrntTblHeders(reqList);
    setEditColModVsble(false);
  };

  const totalPage = Math.ceil(
    (serviceAppointments?.totalRecords ?? 0) / rowsPerPage,
  );

  const handleChangePage = (e, selectedPage) => {
    onApiCall(selectedPage);
  };

  const getTableData = () => {
    return (serviceAppointments?.data ?? [])?.map((li) => {
      return {
        ...li,
        appointmentDateAndTime:
          li?.appointmentDateTime?.length > 0
            ? moment(new Date(li?.appointmentDateTime)).format(
                "DD MMM YYYY, HH:mm",
              )
            : null,
        revenue: Number(li?.revenue ?? 0)?.toFixed(2),
        discount: Number(li?.discount ?? 0)?.toFixed(2),
        discountCode:
          li?.discountCode?.length > 0 ? li?.discountCode?.toString() : null,
        sellingPrice: Number(li?.servicePrice)?.toFixed(2),
      };
    });
  };

  const handleOpenChart = () => {
    console.log("Log triggered");
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    setSearchValues({
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    });
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({ ...initFilter, selectedList: [], values: {} });
    });
    onApiCall(1, true);
  };

  const getVetList = () => {
    if (!allServiceAppointments?.data) return [];
    const reqList = (allServiceAppointments?.data ?? [])
      ?.map((li) => li?.vetName)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const getPetList = () => {
    if (!allServiceAppointments?.data) return [];
    const reqList = (allServiceAppointments?.data ?? [])
      ?.map((li) => li?.petName)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const getServiceList = () => {
    if (!allServiceAppointments?.data) return [];
    const reqList = (allServiceAppointments?.data ?? [])
      ?.map((li) => li?.serviceName)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const getCategoryList = () => {
    if (!allServiceAppointments?.data) return [];
    const reqList = (allServiceAppointments?.data ?? [])
      ?.map((li) => li?.catecory)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    const reqDropList = uniqList?.map((li) => ({ name: li, value: li }));
    return reqDropList;
  };

  const onApplyFilter = () => {
    onApiCall();
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = {
      ...initFilter,
      visible: true,
      selectedList: [],
      values: {},
    };
    setFilterValues(reqObj);
  };

  const getSuggestionList = (typ) => {
    if (!typ) return [];
    if (typ === "SAC Code") return getSacCodes();
    if (typ === "Variant Name") return getVariantNames();
    if (typ === "Variant ID") return getVariantNumbers();
  };

  const getSubcategoryList = () => {
    if (!allServiceAppointments?.data) return [];
    const reqList = (allServiceAppointments?.data ?? [])
      ?.map((li) => li?.subcategory)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    const reqDropList = uniqList?.map((li) => ({ name: li, value: li }));
    return reqDropList;
  };

  const getSacCodes = () => {
    if (!allServiceAppointments?.data) return [];
    const reqList = (allServiceAppointments?.data ?? [])
      ?.map((li) => li?.hsnSacCode)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const getVariantNames = () => {
    if (!allServiceAppointments?.data) return [];
    const reqList = (allServiceAppointments?.data ?? [])
      ?.map((li) => li?.variantName)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const getVariantNumbers = () => {
    if (!allServiceAppointments?.data) return [];
    const reqList = (allServiceAppointments?.data ?? [])
      ?.map((li) => li?.variantNumber)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const getFieldName = (name, type) => {
    if (name === "Appt Date") {
      if (type === "start") return "Min Date";
      return "Max Date";
    }
    if (name === "Revenue") {
      if (type === "start") return "Min Revenue";
      return "Max Revenue";
    }
    if (name === "Discount") {
      if (type === "start") return "Min Discount";
      return "Max Discount";
    }
    if (name === "Time Spent") {
      if (type === "start") return "Min Time Spent";
      return "Max Time Spent";
    }
    if (name === "Selling Price") {
      if (type === "start") return "Min Selling Price";
      return "Max Selling Price";
    }
  };

  const getDropListByType = (typ) => {
    if (!typ) return [];
    if (typ === "Type") return ServiceTypes;
    if (typ === "Subcategory") return getSubcategoryList();
  };

  return (
    <>
      <div className="flex-row mv10">
        <div className="top-row-cen-con w100Per">
          <div className="w15Per">
            <CustomTextField
              options={getVetList()}
              value={searchValues?.vetName}
              name="vetName"
              handleChange={onSearchChange}
              label="Vet Name"
              backgroundColor={AppColors.lightBlue2}
              fullWidth
              suggetions
            />
          </div>
          <div className="w15Per ml20">
            <CustomTextField
              options={getPetList()}
              value={searchValues?.petName}
              name="petName"
              handleChange={onSearchChange}
              label="Pet Name"
              backgroundColor={AppColors.lightBlue2}
              fullWidth
              suggetions
            />
          </div>
          <div className="w15Per ml20">
            <CustomTextField
              options={getServiceList()}
              value={searchValues?.serviceName}
              name="serviceName"
              handleChange={onSearchChange}
              label="Service Name"
              backgroundColor={AppColors.lightBlue2}
              fullWidth
              suggetions
            />
          </div>
          <div className="w15Per ml20">
            <CustomSelect
              list={getCategoryList()}
              value={searchValues?.category ?? []}
              name="category"
              handleChange={onSearchChange}
              label="Category"
              backgroundColor={AppColors.lightBlue2}
              multiSelectSearchCheck
            />
          </div>
          <div
            className="flex-row-ali-cen ml20 filter cursor"
            onClick={() => onFilterChange("visible", true)}
          >
            <TuneIcon sx={{ color: AppColors.appPrimary }} />
            <Typography className="font-medium fs12 blue-color ml10">
              {filterValues?.selectedList?.length > 0
                ? `${filterValues?.selectedList?.length} `
                : ""}
              Filter
            </Typography>
          </div>
          <div className="ml20">
            <CustomButton text="Reset" onClick={onReset} smallBtn redBtn />
          </div>
          <div
            className="flex-row-ali-cen ml20 cursor"
            onClick={handleEditColumn}
          >
            <EditOutlinedIcon sx={w20h20BlueIcon} />
            <Typography className="blue-color fs16 font-medium ml5">
              Edit columns ({crntTblHeders?.length})
            </Typography>
          </div>
          <div
            className="flex-row-ali-cen ml20 cursor"
            onClick={handleOpenChart}
          >
            <AutoGraphIcon sx={w20h20BlueIcon} />
          </div>
        </div>
      </div>
      <Typography className="font-medium fs12 gray28 ml30">
        Number of Records: {serviceAppointments?.totalRecords ?? 0}
      </Typography>
      <div className="mtMin10">
        <ReportTable
          datas={getTableData()}
          columns={crntTblHeders}
          maxHeight="56vh"
        />
        <div className="flex1-end mtMin30">
          {Math.ceil((serviceAppointments?.totalRecords ?? 0) / rowsPerPage) >
          1 ? (
            <TableFooter>
              <TableRow>
                <TableCell colSpan={12}>
                  <div className="flex1-end">
                    <Pagination
                      count={totalPage}
                      variant="outlined"
                      color="primary"
                      page={page}
                      onChange={handleChangePage}
                    />
                  </div>
                </TableCell>
              </TableRow>
            </TableFooter>
          ) : null}
        </div>
      </div>

      <CustomModal
        open={editColModVsble}
        onClose={onEditModClose}
        header="Columns"
        modal
        modalWidth={25}
      >
        <div className="ph20 scroll-70vh">
          {activeTableHeaders?.map((hr) => (
            <div className="flex-row" key={hr?.i}>
              <CustomCheckbox
                label={nameExpan?.[hr?.name]}
                checked={hr?.isSelected}
                onChange={() => handleSelcetdColumn(!hr?.isSelected, hr?.i)}
              />
            </div>
          ))}
          <div className="flex-end mb10">
            <div>
              <CustomButton
                text="Save"
                smallBtn
                onClick={handleSaveTableColumn}
              />
            </div>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => {
                      return (
                        <div className="mt20">
                          {dropFields?.includes(li) ? (
                            <CustomSelect
                              list={getDropListByType(li)}
                              value={filterValues?.values?.[li] ?? []}
                              name={li}
                              handleChange={onFilterValuesChange}
                              label={li}
                              multiSelectSearchCheck
                            />
                          ) : splitRows?.includes(li) ? (
                            <div className="flex-row-between-align-center">
                              <div className="w45Per">
                                <CustomTextField
                                  placeholder={getFieldName(li, "start")}
                                  fullWidth
                                  name={getFieldName(li, "start")}
                                  handleChange={onFilterValuesChange}
                                  value={
                                    filterValues?.values?.[
                                      getFieldName(li, "start")
                                    ] ?? ""
                                  }
                                  label={getFieldName(li, "start")}
                                  mobileDate={li === "Appt Date"}
                                  type="number"
                                />
                              </div>
                              <div className="w45Per">
                                <CustomTextField
                                  placeholder={getFieldName(li, "end")}
                                  fullWidth
                                  name={getFieldName(li, "end")}
                                  handleChange={onFilterValuesChange}
                                  value={
                                    filterValues?.values?.[
                                      getFieldName(li, "end")
                                    ] ?? ""
                                  }
                                  label={getFieldName(li, "end")}
                                  mobileDate={li === "Appt Date"}
                                  type="number"
                                />
                              </div>
                            </div>
                          ) : (
                            <CustomTextField
                              placeholder={li}
                              fullWidth
                              name={li}
                              handleChange={onFilterValuesChange}
                              value={filterValues?.values?.[li] ?? ""}
                              label={li}
                              suggetions
                              options={getSuggestionList(li)}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default ServiceLevel2Report;
